import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  OnInit,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable, Subject, filter, takeUntil } from 'rxjs';
import { LoadingService } from './modules/components/loading/loading.service';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import {
  AccountInfo,
  EventMessage,
  EventType,
  InteractionStatus,
} from '@azure/msal-browser';
import { AuthService } from './modules/services/auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  showNavbar = true;
  title = 'plt-concessao-licenciamento-token-ui';
  isLoading$: Observable<boolean> | null = null;
  tokenExpiration: string = '';
  loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private userAuthService: AuthService,
  ) {}

  ngOnInit() {
    this.isLoading$ = this.loadingService.isLoading$;

    localStorage.setItem('SystemName', 'SISREG');

    this.authService.instance
      .initialize()
      .then(() => {
        this.checkAndSetActiveAccount();
        this.setLoginDisplay();

        this.msalBroadcastService.inProgress$
          .pipe(
            filter(
              (status: InteractionStatus) => status === InteractionStatus.None
            ),
            takeUntil(this._destroying$)
          )
          .subscribe(() => {
            this.setLoginDisplay();
          });

        this.msalBroadcastService.msalSubject$
          .pipe(
            filter(
              (msg: EventMessage) =>
                msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
            )
          )
          .subscribe((msg) => {
            const payload = msg.payload as any;
            this.tokenExpiration = payload?.expiresOn;
            localStorage.setItem('tokenExpiration', this.tokenExpiration);
            if (payload?.account) {
              this.authService.instance.setActiveAccount(payload.account);
            }
            if (payload?.accessToken) {
              this.userAuthService.onLogin(payload.accessToken);
            }
          });
      })
      .catch((err) => {
        console.error('MSAL Initialization Failed', err);
      });

    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = event.urlAfterRedirects || event.url;

        this.showNavbar =
          !(currentUrl === '/') &&
          !currentUrl.includes('auth/sign-up') &&
          !currentUrl.includes('auth/recover') &&
          !currentUrl.includes('recuperar-senha') &&
          !currentUrl.includes('redefinir-senha') &&
          !currentUrl.includes('/login');
      }
    });
  }

  ngAfterViewInit() {
    this.isLoading$?.subscribe(() => {
      this.cdr.detectChanges();
    });
  }

  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
  }

  checkAndSetActiveAccount() {
    let activeAccount: AccountInfo | null =
      this.authService.instance.getActiveAccount();

    if (
      !activeAccount &&
      this.authService.instance.getAllAccounts().length > 0
    ) {
      let accounts = this.authService.instance.getAllAccounts();
      this.authService.instance.setActiveAccount(accounts[0]);
    }
  }

  logout() {
    this.authService.logoutRedirect();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
